/**
 * Created by Karan variya on 22/12/2018.
 */
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { FillingStationDeletedModel } from './fillingstationdeleted';
import { FillingStationDeleted } from './fs';
import { HttpManagerService } from '../httpmanager.service';
@Injectable()
export class FillingStationDeletedService {
    constructor(
        private httpmanagerService: HttpManagerService
    ) {
    }
    allData(): Promise<any> {
        var data = {
        }
        return this.httpmanagerService.HttpPost('sfillingstationdeleted/alldata', JSON.stringify(data), "").then(data => {
            return data.data;
        })
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/api/fillingstationdeleted/fillingstationdeleted.service.ts